"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateAddressResponseMapper = void 0;
var ValidateAddressResponseMapper = /** @class */ (function () {
    function ValidateAddressResponseMapper(data) {
        this.localData = data;
    }
    ValidateAddressResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ValidateAddressResponseMapper;
}());
exports.ValidateAddressResponseMapper = ValidateAddressResponseMapper;
//# sourceMappingURL=ValidateAddressResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/ValidateAddressResponseMapper.js
// module id = 2071
// module chunks = 8